// src/RegisterUsers.js
import React, { useEffect } from "react";

export default function RegisterUsers({ onBack }) {
  useEffect(() => {
    // You can keep this file for compatibility; user creation is now in Users List (UsersManager)
  }, []);

  return (
    <div style={{ padding: 18 }}>
      <h2>Register Users</h2>
      <div style={{ padding: 12, border: "1px solid #ddd", borderRadius: 12, background: "#fafafa" }}>
        User registration has been moved to <b>View Users</b> (Users Manager), where Admin can assign exact permissions.
      </div>
      <div style={{ marginTop: 12 }}>
        <button onClick={onBack} style={{ padding: "10px 14px", borderRadius: 10, border: "1px solid #ddd" }}>
          ⬅ Back
        </button>
      </div>
    </div>
  );
}